import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable,Subject } from 'rxjs';
import { SnackbarService } from '../_service/message-service';
import { environment } from '../../environments/environment';
import { User } from '../_models';
import { CommonService } from './common.service';
import { TranslateService } from '@ngx-translate/core';
import * as countriesAndTimezones from 'countries-and-timezones';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;
  private localInfoSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  private localCurrencySubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public getlocalInfo: Observable<any> = this.localInfoSubject.asObservable();
  private showButtonSubject = new BehaviorSubject<boolean>(false);
  showReloadButton$ = this.showButtonSubject.asObservable();
  private buttonClickSubject = new Subject<void>();
  buttonClick$ = this.buttonClickSubject.asObservable();
  private localInfo: any;
  private localCurrency: any;
  openedViaDialog = false;
  selectedOperator = '';
  mapIconUrlGray ='';
  mapIconUrlGreen='';
  userEmail='';
  addStationTariff ='';
  routeName = '';
  isCreateVendor = false;
  createdOperatorID = '';
  cmsUserID ;
  landingSubject$ = new BehaviorSubject(undefined);
  Timeregex = /^([+-])(\d{2}):(\d{2})$/;

  constructor(private commonService: CommonService,
    private toastr: SnackbarService,readonly translate: TranslateService,
  ) {
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }
  public set setLocalInfo(info) {
    this.localInfo = info;
    this.localInfoSubject.next(this.localInfo);
  }
  public set setLocalCurrency(cur) {
    this.localCurrency = cur;
    this.localCurrencySubject.next(this.localCurrency)
  }
  public get getLocalCurrency() {
    return this.localCurrency
  }

  login(key: string, password: string, role: string) {
    return this.commonService.postCall(`${environment.API_BASE_PATH}/signin`, { key, password, role }, { observe: "response" })  //TODO
  }

  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
    this.currentUserSubject.next(null);
    //this.cookies.remove('SESSION');
  }

  loginuser(data): Observable<any> {
    return this.commonService.postCall(environment.API_BASE_PATH + '/signin', data); //TODO
  }

  forgotpassword(headers): Observable<any> {
    return this.commonService.getCall(environment.API_BASE_PATH + `/forgot`, { headers: headers });  //TODO
  }

  resetpassword(token, password): Observable<any> {
    return this.commonService.getCall(environment.API_BASE_PATH + `/reset?token=${token}&password=${password}`);  //TODO
  }

  // allow only numbers 
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  numberOnlyExceptZero(event): boolean {
    const inputValue = event.target.value;
    const charCode = (event.which) ? event.which : event.keyCode;
    if (/^\d*$/.test(inputValue)) {
      if (inputValue.length > 0 && charCode === 48) {
        return true;
      }
      if (charCode >= 49 && charCode <= 57) {
        return true;
      }
    }
    return false;
  }


  // allow only alphabets 
  alphaonly(e: any) {
    var regex = new RegExp("^[a-zA-Z ]+$");
    var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    if (regex.test(str)) {
      return true;
    }
    e.preventDefault();
    return false;
  }
  alphaonlyWithoutSpace(e: any) {
    var regex = new RegExp("^[a-zA-Z]+$");
    var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    if (regex.test(str)) {
      return true;
    }
    e.preventDefault();
    return false;
  }

  alphaNumericOnly(e: any) {
    var regex = new RegExp("^[a-zA-Z0-9 ]+$");
    var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    if (regex.test(str)) {
      return true;
    }
    e.preventDefault();
    return false;
  }

  // allow up to 2 decimals.
  decimalFilter(event: any) {
    const reg = /^-?\d*(\.\d{0,2})?$/;
    let input = event.target.value + String.fromCharCode(event.charCode);
    if (!reg.test(input)) {
      event.preventDefault();
    }
  }

  setTariffDialog(value) {
    this.openedViaDialog = value;
  }

  getTariffDialog() {
    return this.openedViaDialog;
  }

  setVendorID(value) {
    this.isCreateVendor = value;
  }

  getVendorID(): boolean {
    return this.isCreateVendor;
  }

  setOperatorForTariff(value) {
    this.selectedOperator = value;
  }

  getOperatorForTariff() {
    return this.selectedOperator;
  }

  setCmsUserID(value) {
    this.cmsUserID = value;
  }

  getCmsUserID() {
    return this.cmsUserID;
  }

  setCreatedOperatorId(value) {
    this.createdOperatorID = value;
  }

  getCreatedOperatorId() {
    return this.createdOperatorID;
  }

  convertToLocalTime(date: string, country: string) {
    const dateIn: Date = new Date(date);
    if(!!country){
      let timezonesForCountry = countriesAndTimezones.getTimezonesForCountry(country);
      let inputString = timezonesForCountry[0].dstOffsetStr;
      let resultArray = this.parseTimeString(inputString);
      let dateOut = this.adjustDateBasedOnSign(dateIn,resultArray);
      return dateOut.replace("T", " ").substring(0, 19);
      } else{
        return dateIn.toISOString().replace("T", " ").substring(0, 19);
      }
  }

  setMapIconGray(value){
    this.mapIconUrlGray = value;
  }

  getMapIconGray(){
    return this.mapIconUrlGray;
  }

  setMapIconGreen(value){
    this.mapIconUrlGreen = value;
  }

  getMapIconGreen(){
    return this.mapIconUrlGreen;
  }

  setEmail(value){
    this.userEmail = value;
  }

  getEmail(){
    return this.userEmail;
  }

  setAddStationTariff(value){
    this.addStationTariff = value;
  }

  getAddStationTariff(){
    return this.addStationTariff;
  }

  convert24HrTo12Hr(timestamp: string,transSeconds: boolean = false): string {
    let date = new Date(timestamp);
    if (isNaN(date.getTime())) {
      date = new Date(timestamp.replace('T', ' ').replace('Z', ''));
    }
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    const period = hours < 12 ? 'AM' : 'PM';
    let formattedHours = hours % 12;
    formattedHours = formattedHours === 0 ? 12 : formattedHours;
    const formattedTime = transSeconds
    ? `${formattedHours.toString().padStart(2, '0')}:${this.padZero(minutes)}:${this.padZero(seconds)} ${period}`
    : `${formattedHours.toString().padStart(2, '0')}:${this.padZero(minutes)} ${period}`;
    const formattedDate = `${year}-${this.padZero(month)}-${this.padZero(day)}`;
    return `${formattedDate} ${formattedTime}`;
  }

  private padZero(num: number): string {
    return num < 10 ? `0${num}` : `${num}`;
  }

  convertToBase64(input: string): string {
    if (typeof input !== 'string') {
      this.toastr.error(this.translate.instant('rfid.input_string'));
      return null;
    }
    const base64Encoded = btoa(input);
    return base64Encoded;
  }

  setRouteFromVendorDetails(value){
    this.routeName = value;
  }

  getRouteFromVendorDetails(){
    return this.routeName;
  }

  convertToLocalTimeForPayload(date, country: string) {
    if(!!country){
    let timezonesForCountry = countriesAndTimezones.getTimezonesForCountry(country);
    let inputString = timezonesForCountry[0].dstOffsetStr;
    let resultArray = this.parseTimeString(inputString);
    let dateOut = this.adjustDateBasedOnSignForPayload(date,resultArray);
    return dateOut;
    } else{
      return date.toISOString();
    }
  }
  
  parseTimeString(inputString) {
    const match = inputString.match(this.Timeregex);
    return match ? [match[1], parseInt(match[2]), parseInt(match[3])] : null;
  }

  adjustDateBasedOnSignForPayload(dateIn, resultArray) {
    const [sign, hours, minutes] = resultArray;
    const multiplier = sign === "+" ? -1 : 1;
    dateIn.setHours(dateIn.getHours() + multiplier * hours);
    dateIn.setMinutes(dateIn.getMinutes() + multiplier * minutes);
    return dateIn.toISOString();
  }

  adjustDateBasedOnSign(dateIn,resultArray) {
    const [sign, hours, minutes] = resultArray;
    const multiplier = sign === "+" ? 1 : -1;
    dateIn.setHours(dateIn.getHours() + multiplier * hours);
    dateIn.setMinutes(dateIn.getMinutes() + multiplier * minutes);
    return dateIn.toISOString();
  }

  convertToAmPmWithPrefCountry(timestamp:string,country:string) {
    const dateIn = new Date(timestamp)
    if (!!country) {
      const timezonesForCountry = countriesAndTimezones.getTimezonesForCountry(country);
      const inputString = timezonesForCountry[0].dstOffsetStr;
      const resultArray = this.parseTimeString(inputString);
      const dateOutString = this.adjustDateBasedOnSign(dateIn, resultArray);
      const date = new Date(Date.parse(dateOutString));
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, '0');
      const day = String(date.getUTCDate()).padStart(2, '0');
      const hours = String(date.getUTCHours() % 12 || 12).padStart(2, '0');
      const minutes = String(date.getUTCMinutes()).padStart(2, '0');
      const period = date.getUTCHours() < 12 ? 'AM' : 'PM';
      const formattedString = `${year}-${month}-${day} ${hours}:${minutes} ${period}`;
      return formattedString;
    } else {
      return timestamp;
    }
  }

  normalizeState(state) {
    switch (state) {
      case 'TG':
        return 'TS';
      case 'CT':
        return 'CG';
      default:
        return state;
    }
  }

  reverseNormalizeState(state) {
    switch (state) {
      case 'TS':
        return 'TG';
      case 'CG':
        return 'CT';
      default:
        return state;
    }
  }

  setShowButton(show: boolean): void {
    this.showButtonSubject.next(show);
  }

  triggerButtonClick(): void {
    this.buttonClickSubject.next();
  }

  getTimeZoneOffsetString(country:string) {
    if(!!country) {
      const timezonesForCountry = countriesAndTimezones.getTimezonesForCountry(country);
      return timezonesForCountry[0].dstOffsetStr;
    } else {
      return null;
    }
  }
}
